// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./base.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#app {
  max-width: 1280px;
  margin: 0 auto;
  padding: 2rem;
  font-weight: normal;
}

a,
.green {
  text-decoration: none;
  color: hsla(160, 100%, 37%, 1);
  transition: 0.4s;
  padding: 3px;
}

@media (hover: hover) {
  a:hover {
    background-color: hsla(160, 100%, 37%, 0.2);
  }
}

@media (min-width: 1024px) {
  body {
    display: flex;
    place-items: center;
  }

  #app {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 0 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/main.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,eAAe;EACjB;AACF","sourcesContent":["@import './base.css';\r\n\r\n#app {\r\n  max-width: 1280px;\r\n  margin: 0 auto;\r\n  padding: 2rem;\r\n  font-weight: normal;\r\n}\r\n\r\na,\r\n.green {\r\n  text-decoration: none;\r\n  color: hsla(160, 100%, 37%, 1);\r\n  transition: 0.4s;\r\n  padding: 3px;\r\n}\r\n\r\n@media (hover: hover) {\r\n  a:hover {\r\n    background-color: hsla(160, 100%, 37%, 0.2);\r\n  }\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n  body {\r\n    display: flex;\r\n    place-items: center;\r\n  }\r\n\r\n  #app {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    padding: 0 2rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
